




























































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import PermintaanObatPaketSvc from "@/services/PermintaanObatPaket";
import AntimikrobaReserveForm from "@/components/pemeriksaan/resep-obat/lembar-permintaan/AntimikrobaReserve/AntimikrobaReserveForm.vue";
import {
  formatWaktu,
  statusAlur,
  PermintaanAntimikroba
} from "@/components/pemeriksaan/resep-obat/lembar-permintaan/AntimikrobaReserve/antimikrobaReserve.config";

@Component({
  components: { AntimikrobaReserveForm }
})
export default class PermintaanAntimikrobaReservePage extends Vue {
  loading = false;
  items: PermintaanAntimikroba[] = [];
  status = "aktif";
  dari = moment().subtract(30, "days").format("YYYY-MM-DD");
  sampai = moment().format("YYYY-MM-DD");
  dialog = false;
  terpilih: PermintaanAntimikroba | null = null;
  muatKe = 0;

  statusItems = [
    { text: "Belum selesai", value: "aktif" },
    { text: "Menunggu KPRA", value: "menunggu_kpra" },
    { text: "Menunggu Verifikasi", value: "menunggu_verifikasi" },
    { text: "Terverifikasi", value: "terverifikasi" },
    { text: "Semua", value: "semua" }
  ];

  headers = [
    { text: "Dikirim", value: "dikirim_at", width: "130px" },
    { text: "Pasien", value: "pasien", sortable: false },
    { text: "Ruang", value: "ruang_rawat", sortable: false },
    { text: "Antimikroba", value: "antimikroba", sortable: false },
    { text: "DPJP", value: "dpjp", sortable: false },
    { text: "Status", value: "status_alur", sortable: false },
    { text: "Aksi", value: "actions", sortable: false, width: "140px" }
  ];

  get pakaiPeriode(): boolean {
    return this.status === "terverifikasi" || this.status === "semua";
  }

  mounted() {
    this.muat();
  }

  async muat() {
    const ke = ++this.muatKe;
    const params: Record<string, string> = { status: this.status };
    if (this.pakaiPeriode) {
      params.dari = this.dari;
      params.sampai = this.sampai;
    }
    this.loading = true;
    try {
      const resp = await PermintaanObatPaketSvc.listAntimikroba(params);
      if (ke !== this.muatKe) return;
      this.items = resp.data.status === "1" ? resp.data.data : [];
    } catch {
      if (ke === this.muatKe) this.items = [];
    } finally {
      if (ke === this.muatKe) this.loading = false;
    }
  }

  statusAlur(status: string) {
    return statusAlur(status);
  }

  formatWaktu(nilai: string | null) {
    return formatWaktu(nilai);
  }

  namaAntimikroba(item: PermintaanAntimikroba) {
    return (item.items || []).map(i => i.nama_antimikroba).join(", ");
  }

  buka(item: PermintaanAntimikroba) {
    this.terpilih = item;
    this.dialog = true;
  }

  cetak(item: PermintaanAntimikroba) {
    PermintaanObatPaketSvc.print(item.id);
  }

  onSaved() {
    this.dialog = false;
    this.muat();
  }
}
